import React from 'react';
import { Breadcrumbs, ListBreadcrumbItem } from 'framework/ui/BreadCrumbs';
import { useAccountingCycleUrl } from './useAccountingCycleRouting';
import { BreadcrumbsProps } from 'framework/ui/BreadCrumbs';

const AccountingCycleBreadcrumbs = ({ children }: BreadcrumbsProps) => {
  const { getListUrl } = useAccountingCycleUrl();
  const wasteListLink = getListUrl();

  return (
    <Breadcrumbs>
      <ListBreadcrumbItem entity="Accounting Cycles" link={wasteListLink} />
      {children}
    </Breadcrumbs>
  );
};

export default AccountingCycleBreadcrumbs;
